export enum FTNIStatus {
	Loading = 'loading',
	Ready = 'ready',
	Fatal = 'fatal',
	Declined = 'declined',
	Error = 'error',
	Canceled = 'canceled',
}
